// extracted by mini-css-extract-plugin
module.exports = {"dangerButton":"dangerButton_dangerButton__3aHxw"};